import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface OrderingInfoState {
  menu: unknown | null;
  deliveryTaxRate: unknown | null;
  stockLevels?: unknown | null;
}

const initialState: OrderingInfoState = {
  menu: null,
  deliveryTaxRate: null,
  stockLevels: null,
};

/**
 * TODO: move to react-query.
 */
const {
  reducer: orderingInfoReducer,
  actions: { updateOrderingInfo },
} = createSlice({
  name: "orderingInfo",
  initialState,
  reducers: {
    updateOrderingInfo(
      state,
      { payload: orderingInfo }: PayloadAction<OrderingInfoState>
    ) {
      return orderingInfo;
    },
  },
});

export { orderingInfoReducer, updateOrderingInfo };
